import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(id, query) {
    return await requestWrapper(null, 'GET', `/requirement_classes/${id}`, query);
  },
  async create(req, query) {
    return await requestWrapper(null, 'POST', '/requirement_classes', query, req);
  },
  async getLinked(id, query) {
    return await requestWrapper(null, 'GET', `/requirements/${id}/linked_classes`, query);
  },
  async update(req) {
    return await requestWrapper(null, 'PUT', `/requirement_classes/${req.id}`, null, req);
  },
  async remove(id, class_id) {
    return await requestWrapper(null, 'DELETE', `/requirement_classes/${id}/${class_id}`);
  },
};
